import clsx from 'clsx';
import { ArrowPathIcon } from '@heroicons/react/20/solid';
import { Button } from '../../catalyst/button';

type Props = {
  /** A fetch is running: the icon spins and the button waits. */
  fetching: boolean;
  onRefresh: () => void;
};

/** Fetches the graph again, in the header's description line; the view state stays as it is. */
export function RefreshButton({ fetching, onRefresh }: Props) {
  return (
    <Button
      plain
      disabled={fetching}
      onClick={onRefresh}
      // Line height, so the description line keeps its height.
      buttonClassName="ml-1 gap-x-1 px-1.5 py-0 align-baseline text-sm/5 font-medium text-zinc-600 sm:px-1.5 sm:py-0 sm:text-sm/5 dark:text-zinc-300"
    >
      <ArrowPathIcon data-slot="icon" className={clsx(fetching && 'animate-spin')} />
      Refresh
    </Button>
  );
}
